import { Allocation, DefaultService } from "@/api/SolarCloudApi";
import { MutationConfig } from "@/lib/react-query";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import getPersonalAllocationsQueryOptions from "./usePersonalAllocations";
import getTrackerEventsQueryOptions from "../tracker/useTrackerEvents";

export function updatePersonalAllocations(data: Allocation[]) {
  console.log("updatePersonalAllocations", data);
  const response = DefaultService.updatePersonalAllocations(data);
  return response;
}

type UseUpdatePersonalAllocationsOptions = {
  mutationConfig?: MutationConfig<typeof updatePersonalAllocations>;
};
export function useUpdatePersonalAllocations({
  mutationConfig,
}: UseUpdatePersonalAllocationsOptions = {}) {
  const queryClient = useQueryClient();
  const allocationQueryKey = getPersonalAllocationsQueryOptions().queryKey;

  const { onSuccess, ...restConfig } = mutationConfig || {};

  return useMutation({
    ...restConfig,
    mutationFn: updatePersonalAllocations,
    onSuccess: (data, ...args) => {
      onSuccess?.(data, ...args);
      toast.success("Allocation saved");
      queryClient.invalidateQueries({
        queryKey: getTrackerEventsQueryOptions().queryKey,
      });
    },
    onMutate: async (newAllocations) => {
      await queryClient.cancelQueries({
        queryKey: allocationQueryKey,
      });

      const previousAllocations = queryClient.getQueryData(allocationQueryKey);

      queryClient.setQueryData(allocationQueryKey, newAllocations);
      return { previousAllocations };
    },
    onError: (error, newAllocations, context) => {
      const safeContext = context as { previousAllocations?: Allocation[] };
      queryClient.setQueryData(
        allocationQueryKey,
        safeContext?.previousAllocations as Allocation[]
      );
      toast.error("Failed to save allocation");
    },
    onSettled: () =>
      setTimeout(() => {
        // todo: investigate alternate way to stop flicker
        queryClient.invalidateQueries({ queryKey: allocationQueryKey });
      }, 100),
  });
}
